import React, { Component } from 'react'
import { connect } from 'react-redux'
import logoPublic from '../../assets/images/logo-animado-2.gif'
import logoPrivate from '../../assets/images/white_logo.gif'

import logoSmallGif from '../../assets/images/logo-animado-small.gif'

export class Logo extends Component {
  render() {
    const { privLogo, isNavbar } = this.props
    return (
      <React.Fragment>
        {privLogo && (
          <img
            className={
              isNavbar ? 'nav-bunkey-logo-desktop' : 'bunkey-logo-desktop'
            }
            src={isNavbar ? logoSmallGif : logoPrivate}
            alt="Bunkey"
            onClick={this.props.onClick}
          />
        )}
        {!privLogo && (
          // <img
          //   className="bunkey-logo-desktop"
          //   src={logoSmallGif}
          //   alt="Bunkey"
          //   onClick={this.props.onClick}
          // />
          <img
            onClick={this.props.onClick}
            src={logoPublic}
            alt="Bunkey"
            className="pub-site-logo"
          />
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = () => {
  return {}
}

export default connect(mapStateToProps)(Logo)
